import type { Basket, BasketItemType } from '@reward-platform/order-schemas/basket'
import {
  CarHireItemType,
  ExperienceItemType,
  FlightItemType,
  HotelItemType,
} from '@reward-platform/order-schemas/common'
import type { PlatformThemeId } from '@reward-platform/platform-config'

export const getBasketItemTypesToClearOnPlatformSwitch = (
  theme: PlatformThemeId
): BasketItemType[] => {
  if (theme === 'avios') {
    return [FlightItemType]
  }

  return [HotelItemType, CarHireItemType, ExperienceItemType]
}

export const getBasketHasPlatformSwitchContamination = (
  basket: Basket | undefined,
  theme: PlatformThemeId
): boolean => {
  const itemTypesToClear = getBasketItemTypesToClearOnPlatformSwitch(theme)

  return itemTypesToClear.some((itemType) => Boolean(basket?.items[itemType].length))
}
